export const CivilHearing = [
    { value: 'AIJ', label: 'AIJ' },
    { value: 'Conciliação', label: 'Conciliação' },
    { value: 'Instruções e Julgamento', label: 'Instruções e Julgamento' },
    { value: 'Procon', label: 'Procon' },
    { value: 'Sustentação Oral', label: 'Sustentação Oral' },
    { value: 'Outros', label: 'Outros' },
];